import { ChakraProvider } from '@chakra-ui/react'
import ReactDOM from 'react-dom'
import { Provider, appContext } from './data/stores/rootStore'
import { Global } from '@emotion/react'

import Theme from './theme/theme'
import { App } from './App'

ReactDOM.render(
  <ChakraProvider theme={Theme}>
    <Global
      styles={{
        body: {
          backgroundColor: Theme.colors.nrr.backgroundGray,
        },
      }}
    />
    <Provider value={appContext}>
      <App />
    </Provider>
  </ChakraProvider>,
  document.getElementById('root')
)
